import { Button, CssBaseline, Grid, Stack, ThemeProvider } from "@mui/material";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { DatePicker, Radio, Row, Select } from "antd";
import moment from 'moment';
import { Component } from "react";
import { connect } from "react-redux";
import { applyCaseFilters, clearAllFilters } from "../../redux_actions/search.case.action";
import { caseArchiveStatusEnum, caseReadStatusEnum } from "../../utils/const";
import { isNull, isTrue, notNull } from "../../utils/utils";
import { defaultTheme } from "../gammaviewer/themes";
import {aclPermissions, hasPermissions} from "../../const/ACLPermissions";

const {RangePicker} = DatePicker
const Option = Select.Option;
var today = new Date();
var dd = today.getDate();

class FilterComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseAssigned: this.props.urlState.case_assigned || false,
            dateRange: [this.props.urlState.date__gte || '', this.props.urlState.date__lte || ''], //Format - [date__gte, date_lte]
            readStatus: this.props.urlState.read_status || caseReadStatusEnum.ALL,
            priority: this.props.urlState.priority,
            case_status: this.props.urlState.case_status,
            archiveStatus: this.props.urlState.archive_status || caseArchiveStatusEnum.ALL,
        };
    }

    handleTypeChange = (value) => {
        this.setState({caseAssigned: value === "case_assigned"})
    }
    handlePriorityChange = (value) => {
        this.setState({priority: value})
    }

    handleCaseStatusChange = (value) => {
        this.setState({case_status: value})
    }
    handleReadStatusChange = (value) => {
        this.setState({readStatus: value})
    }

    handleArchiveStatusChange = (value) => {
        this.setState({archiveStatus: value})
    }

    handleDateRangeChange = (moment) => {
        try{
            const changedDateRange = [moment[0].format("YYYY-MM-DD"), moment[1].format("YYYY-MM-DD")];
            this.setState({dateRange: changedDateRange})
        } catch (err) {
            this.setState({dateRange: ['', '']})
        }
    }

    applyFilters = () => {
        this.props.dispatch(applyCaseFilters(this.props.urlState, 1, this.state.caseAssigned, this.state.readStatus,
            this.state.dateRange[0], this.state.dateRange[1], this.state.priority, this.state.case_status, this.state.archiveStatus))
        this.props.onClose();
    }

    handleClear = () => {
        this.props.dispatch(clearAllFilters());
        this.props.onClose();
    }

    render() {
        return (
            this.props.isFetching === true ?
                <Row>
                </Row>
                :
                <ThemeProvider theme={defaultTheme}>
                    <CssBaseline/>
                <Popover open={true} anchorEl={this.props.anchorEl} onClose={this.props.onClose}
                         anchorOrigin={{vertical: 'bottom', horizontal: 'left',}}
                         transformOrigin={{vertical: 'top', horizontal: 'left',}}
                         sx={{zIndex: 10}}
                >
                    <Stack
                        sx={{width: (notNull(this.props.width) && this.props.width !== -1) ? this.props.width : 100}}>
                        <Grid container spacing={2} sx={{
                            p: 2,
                        }}>
                            <Grid item xs={12}>
                                <Typography variant="h6">Filters </Typography>
                            </Grid>
                            {hasPermissions([aclPermissions.view_all_cases]) ?
                            <>
                                <Grid item xs={4}>
                                <Typography>Assignment: </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Radio.Group value={isTrue(this.state.caseAssigned) ? "case_assigned" : "all"}
                                             onChange={(e) => {
                                                 e.stopPropagation();
                                                 this.handleTypeChange(e.target.value)
                                             }}
                                             className={"purple-radio-group"}
                                >
                                    <Radio.Button value={"case_assigned"}>
                                        Assigned to Me
                                    </Radio.Button>
                                    <Radio.Button value={"all"}>
                                        All
                                    </Radio.Button>
                                </Radio.Group>
                            </Grid>
                            </>: null}

                            <Grid item xs={4}>
                                <Typography>Date Range: </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <RangePicker
                                    dateRender={current => {
                                        const style = {};
                                        if (current.date() === dd) {
                                            style.backgroundColor = "transparent";
                                            style.color = "black";
                                        }
                                        return (
                                            <div className="ant-calendar-date" style={style}>
                                                {current.date()}
                                            </div>
                                        );
                                    }}
                                    showToday
                                    onChange={this.handleDateRangeChange}
                                    value={(isNull(this.state.dateRange[1]) || this.state.dateRange[1].length === 0) ?
                                        undefined : [moment(this.state.dateRange[0], "YYYY-MM-DD"), moment(this.state.dateRange[1], "YYYY-MM-DD")]}
                                    format="YYYY-MM-DD"
                                    defaultValue={[undefined, undefined]}
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <Typography>Read Status: </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Radio.Group defaultValue={this.state.readStatus}
                                             value={this.state.readStatus} onChange={(e) => {
                                    e.stopPropagation();
                                    this.handleReadStatusChange(e.target.value)
                                }}
                                             className={"purple-radio-group"}>
                                    <Radio.Button value={caseReadStatusEnum.READ}>
                                        Read
                                    </Radio.Button>
                                    <Radio.Button value={caseReadStatusEnum.UNREAD}>
                                        Unread
                                    </Radio.Button>
                                    <Radio.Button value={caseReadStatusEnum.ALL}>
                                        All
                                    </Radio.Button>
                                </Radio.Group>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography>Priority: </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Select
                                    value={this.state.priority}
                                    placeholder="Select Priority Filter"
                                    onChange={this.handlePriorityChange}
                                    style={{width: '100%'}}
                                >
                                    <Option value="">All</Option>
                                    {this.props.casePriorities.map((priority_obj) => {
                                        return <Option value={priority_obj?.id}>{priority_obj?.name}</Option>
                                    })
                                    }
                                </Select>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography>Case Status: </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Select
                                    value={this.state.case_status}
                                    placeholder="Select Status of Case"
                                    onChange={this.handleCaseStatusChange}
                                    style={{width: '100%'}}
                                >
                                    <Option value="">All</Option>
                                    {Object.values(this.props.caseStatuses).map((value) => {
                                        return <Option value={value?.id}>{value?.status}</Option>
                                    })
                                    }
                                </Select>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography>Archive Status: </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Radio.Group defaultValue={this.state.archiveStatus}
                                             value={this.state.archiveStatus} onChange={(e) => {
                                    e.stopPropagation();
                                    this.handleArchiveStatusChange(e.target.value)
                                }}
                                             className={"purple-radio-group"}>
                                    <Radio.Button value={caseArchiveStatusEnum.UNARCHIVED}>
                                        Inbox
                                    </Radio.Button>
                                    <Radio.Button value={caseArchiveStatusEnum.ARCHIVED}>
                                        Archived
                                    </Radio.Button>
                                    <Radio.Button value={caseArchiveStatusEnum.ALL}>
                                        All
                                    </Radio.Button>
                                </Radio.Group>
                            </Grid>

                            <Grid item xs={12}>
                                <Stack direction={"row"} color="primary" justifyContent={"flex-end"} spacing={2}>
                                    <Button variant="outlined" disableElevation onClick={this.handleClear} sx={{
                                        textTransform: 'none', borderRadius: '5px'
                                    }}>Clear</Button>
                                    <Button variant="contained" color="primary" disableElevation onClick={this.applyFilters} sx={{
                                        textTransform: 'none', borderRadius: '5px',
                                    }}>Apply</Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Stack>
                </Popover>
                </ThemeProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        isFetching: state.searchCaseReducer.isFetching,
        loginStatus: state.loginAlerts.loginStatus,
        urlState: state.searchCaseReducer,
        morpheusSetting: state.morpheusSettingReducer,
        casePriorities: state.caseStatusReducer.case_priority,
        caseStatuses: state.caseStatusReducer.case_status,
    };
};

export default connect(mapStateToProps)(FilterComp);